export const EAGLE_SOFTWARE_EMAIL_TEMPLATE = {
  to: 'support@eaglesoftware.com.au',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello,

Could you please enable Snug as an upload destination for our agency for the Eagle Software Account(s):

Agency name: [Enter Agency Name]
Agency address: [Enter Agency Address]
Contact name: [Enter Contact Name]
Contact phone: [Enter Contact Phone]
Contact email: [Enter Contact Email]
REAXML Agency ID: [Enter Eagle Software REAXML Agency ID]

 

Thank you,

Head of Property Management`,
}
